import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";

export const faqs = [
  {
    q: "What areas do you serve?",
    a: "We're based in Deltona, FL and serve homeowners across Volusia, Seminole, and Orange counties — including Orange City, Sanford, DeLand, Daytona Beach, Port Orange, Altamonte Springs, Winter Park, and Oviedo.",
  },
  {
    q: "Are estimates really free?",
    a: "Yes. Every project starts with a free, no-pressure estimate. We'll look at the work, explain your options honestly, and give you a clear written scope before anything begins — and new clients receive 10% off their first project.",
  },
  {
    q: "What services do you offer?",
    a: "Interior and exterior painting, ceramic tile and vinyl floor installation, bathroom remodeling, drywall repair, and kitchen cabinet restoration and new cabinet installation.",
  },
  {
    q: "How soon can you start my project?",
    a: "Most estimates are scheduled within a few days, and smaller projects can often start the same week. Larger remodels are scheduled with a clear timeline agreed on before work begins. We work Monday–Friday 8 AM–7 PM and Saturdays 8 AM–4 PM.",
  },
  {
    q: "Do you protect my home while you work?",
    a: "Always. Floors, furniture, and fixtures are covered before work starts, we keep the job site tidy every day, and we do a full cleanup and walkthrough with you before we call the project finished.",
  },
  {
    q: "Do you help customers in both English and Spanish?",
    a: "Yes. We serve families in both languages. For attention in English, call (386) 320-9362. For general questions or service in Spanish, call (786) 306-5704 or email villalobosprime.services@gmail.com.",
  },
];

const FAQSection = () => {
  return (
    <section className="section-padding bg-background">
      <div className="container-max max-w-3xl">
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-block text-primary text-sm font-bold uppercase tracking-widest mb-3"
          >
            FAQ
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground mb-4 tracking-tight font-bold"
          >
            Frequently Asked <span className="text-gradient-primary">Questions</span>
          </motion.h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05, duration: 0.4 }}
            >
              <AccordionItem
                value={`faq-${i}`}
                className="bg-card rounded-xl border border-border px-6 data-[state=open]:shadow-md data-[state=open]:border-primary/20 transition-all"
              >
                <AccordionTrigger className="font-heading text-lg tracking-tight text-foreground hover:no-underline py-5 text-left font-semibold">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm leading-relaxed pb-5 text-left">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            </motion.div>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
